import {SolicitacoesPage} from '@components/solicitacoes/pages/solicitacoes/SolicitacoesPage.tsx';
import {
    SolicitacaoTipoInformacao,
    SolicitacaoTipoInformacaoGrid,
} from '@components/solicitacoes/solicitacao/tipo/SolicitacaoTipoInformacao.tsx';
import {GetSolicitacaoTipos} from '@localization/siteMap/endpoints/_SolicitacoesEnpoints.ts';
import {DefaultPageProps} from '@models/DefaultProps.ts';
import {ISolicitacaoTipo} from '@models/solicitacoes/solicitacoes.ts';
import {Grid, Paper, Tab, Tabs} from '@mui/material';
import {DefaultContainer} from '@shared/DefaultContainer.tsx';
import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate, useSearchParams} from 'react-router';


interface SolicitacaoTipoPageProps extends DefaultPageProps {
}

type tabs = 'detalhes' | 'solicitacoes';

export const SolicitacaoTipoPage: React.FC<SolicitacaoTipoPageProps> = (props) => {
    const [tab, setTab] = useState<tabs>('detalhes');

    const [solicitacaoTipo, setSolicitacaoTipo] = useState<ISolicitacaoTipo | undefined>();
    const [searchParams] = useSearchParams();
    const [solicitacaoId] = useState(searchParams.get('solicitacaoTipoId'));

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setTab(location.hash.slice(1) as tabs || 'detalhes');
    }, [location.hash]);


    useEffect(() => {
        if (solicitacaoId) {
            GetSolicitacaoTipos({
                id: [Number(solicitacaoId)],
                deveIncluir: ['Forms', 'UsuarioCriador', 'Parametros'],
            }, {page: 1, pageSize: 1}).then((x) => {
                if (x.hasData && x.items.length > 0) {
                    setSolicitacaoTipo(x.items[0]);
                } else {
                    setSolicitacaoTipo(undefined);
                }
            });
        }
    }, [solicitacaoId]);

    return (
        <DefaultContainer {...props} titulo={`Solicitação tipo ${solicitacaoId} ${solicitacaoTipo?.nome}`}
                          permissaoNecessaria={['CriarTipoSolicitacao']}
                          component={Paper}>
            {solicitacaoTipo && <Grid>
                <Grid>
                    <SolicitacaoTipoInformacao value={solicitacaoTipo}
                                               variant={'list'}/></Grid>

                <Grid>
                    <Tabs value={tab} onChange={(_e, v) => {
                        navigate({
                            pathname: location.pathname,
                            search: `?solicitacaoTipoId=${solicitacaoTipo.id}`,
                            hash: `#${v}`,
                        });
                    }}>
                        <Tab value={'detalhes'} label={'Detalhes'}/>
                        <Tab value={'solicitacoes'} label={'Solicitações'}/>
                    </Tabs>
                </Grid>
                <Grid mt={1.5}>
                    {tab === 'detalhes' && <SolicitacaoTipoInformacaoGrid value={solicitacaoTipo} onUpdate={(s) => {
                        setSolicitacaoTipo(s);
                    }}/>}
                    {tab == 'solicitacoes' &&
                        <SolicitacoesPage hideHeader filtros={{tipoSolicitacaoId: [solicitacaoTipo.id]}}/>}
                </Grid>

            </Grid>}
        </DefaultContainer>
    );
};